import { useState, useEffect } from "react";

import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../components/loader/loader";
import UserCreationLayout from "../../layouts/userCreation/userCreationLayout";
import IntroSection from "../../components/introSection/introSection";
import PaginationDivider from "../../components/paginationDivider/paginationDivider";
import internshipImg from "../../assets/internshipImg.png";
import { Colors } from "../../utilities/colors";
import Dropdown from "../../components/dropdown/dropdown";
import ErrorField from "../../components/errorField/errorField";
import { secondaryFormValues, secondaryStudentContent, secondaryStudyScheme } from "./secondaryStudentStatic";

import Button from "../../components/button/button";

import {

  getDistrict,
  getSchoolListing,
  getSchoolListingFilter,
  getSchoolsCourses,
  getStates,
  onBoardFormSubmission,
  onBoardStepTwoForm,
} from "../../services/apiCalls";
import { updateValues } from "../selfIntro/reducer";
import { Col, Row } from "react-bootstrap";


import { createTheme, IconButton } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { useTranslation } from "react-i18next";
import { removeKeys } from "../../utilities/commonFunctions";
import MultiSelector from "../../components/dropdown/multiSelector";

const materialTheme = createTheme({
  palette: {
    primary: {
      main: "#D44B9C",
    },
  },
  overrides: {
    MuiPickersCalendarHeader: {
      switchHeader: {
        color: "#D44B9C",
      },
    },
  },
});
// styles start
const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const WidthWrapper = styled.div`
  width: ${(props) => (props.width ? props.width : "100%")};
  @media (max-width: 1024px) {
    width: 70%;
    margin-bottom: 20px;
  }
  @media (max-width: 599px) {
    width: 100%;
  }
`;
const FormWrapper = styled.div`
  margin: 30px 0 0 0;
  max-width: 100%;
  @media (max-width: 1024px) {
    max-width: 100%;
  }
`;
const LabelText = styled.label`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: ${Colors.labelText};
  margin-bottom: 10px;
  display: block;
`;
const FormGroup = styled.div`
  margin-bottom: 25px;
`;
const ScholarshipWrapper = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 599px) {
    margin-bottom: 20px;
  }
  @media (max-width: 412px) {
   display:grid;
   grid-template-columns: 1fr 12fr;
   grid-row-gap:10px;
  }
`;
const InstitutionWrapper = styled(FlexWrapper)`
  @media (max-width: 1024px) {
    display: block;
  }
  justify-content: space-between;
  align-items: start;
`;
const DividerLine = styled.hr`
  border: 0.5px solid #ebebeb;
  margin: 30px 0;
`;
const EnglishTestWrapper = styled.div`
  margin-bottom: 10px;
`;
const DatesWrapper = styled(FlexWrapper)`
  label {
    position: relative;
    width: -webkit-fill-available;
  }
`;
const CalenderIconWrapper = styled.div`
  position: absolute;
  right: 1.5rem;
  top: 0.5rem;
  cursor: pointer;
`;
const InternWrapper = styled(FlexWrapper)`
  > div {
    margin-right: 20px;
  }
`;
const ButtonWrapper = styled(FlexWrapper)`
  justify-content: space-between;
  margin-top: 40px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
  @media (max-width: 1024px) {
    justify-content: space-between;
  }
`;
const SaveButton = styled.p`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  text-decoration-line: underline;
  color: #504f8c;
  margin: 0;
  text-align: left;
  cursor: pointer;
  @media (max-width: 900px) {
    text-align: center;
  }
`;
// styling ends

export default function SecondaryStudent() {
  const formValues = useSelector((state) => state.selfIntroOne.value);
  const value = formValues.talent_status;
  // const options = useSelector((state) => state.selfIntroOne.formOptions);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const [currStudyYear, setCurrStudyYear] = useState([]);
  const [spmYearListing, setSpmYearListing] = useState([]);
  const [spmYearDisabled, setSpmYearDisabled] = useState(true);
  const [formErrors, setFormErrors] = useState("");
  const currentYear = new Date().getFullYear();

  const startYear = currentYear + 1;
  const [spmYearListingOverall, setSpmYearListingOverall] = useState(() => {
    const years = [];
    for (let year = startYear; year <= 2040; year++) {
      years.push({ label: String(year), value: String(year) });
    }
    return years;
  });
console.log("formVlauesas",formValues)
  const {
    control,
    handleSubmit,
    setValue,
    watch,
    resetField,
    setError,

    clearErrors,
    formState: { errors, values },
  } = useForm({
    defaultValues: { ...formValues },
    resolver: yupResolver(secondaryStudyScheme),
    // context: { campusDisable, facultyDisable, programmeDisable },
  });
  const formVal = watch();


  const [selectedUniversity, setSelectedUniversity] = useState([]);
  const [schoolName, setSchoolName] = useState([]);
  const [spmYearValue, setSPMYearValue] = useState();
  const [currentFromValue, setCurrentFormValue] = useState();
  const [form6SubjectsOption, setForm6SubjectsOption] = useState();
  const [elective_sub_45, setElective_sub_45] = useState();
  const [elective_sub_13, setElective_sub_13] = useState();
  const [stemSubjectsValue, setStemSubjectsValue] = useState();
  const [coreSubjectsValues, setCoreSubjectsValues] = useState();
  const [electiveSubjectsValues, setElectiveSubjects] = useState();
  const [selectedState, setSelectedState] = useState();
  const [selectedDistrict, setSelectedDistrict] = useState();
  const [schoolListing, setSchoolListing] = useState([]);
  const [states, setStates] = useState([]);
  const [district, setDistrict] = useState([]);
  const [coreSubjectListing, setCoreSubjectLisitng] = useState([]);
  const [electiveSubjectListing, setElectiveSubjectListing] = useState([]);
  const [studyFormErrors, setStudyFormErrors] = useState(false);
  const [loading, setLoading] = useState(false);
  const [elective_sub_1_3, setElective_sub_1_3] = useState([]);
  const [elective_sub_4_5, setElective_sub_4_5] = useState([]);
  const [form_6_subject, setForm6Subjects] = useState([]);

  const [statesLoading, setStatesLoading] = useState(false);
  const [districtLoading, setDistrictLoading] = useState(false);
  const [schoolsLoading, setSchoolsLoading] = useState(false);
  const [coursesLoading, setCoursesLoading] = useState(false);

//   useEffect(() => {
//     if (!window.allow_user_continue) navigate("/self-intro");
//   }, [window.allow_user_continue]);

  const onErrorSubmit = (err) => {
console.log("showErroData",err)
console.log("formValuesData",formVal)
    // setStudyFormErrors(true);
  };

  const onSubmit = async (dataForm) => {
console.log("dataWeFetched",dataForm)
    setLoading(true);
    const { data } = await onBoardStepTwoForm({
      ...formVal,
      talent_status: formValues.talent_status,
    });
    if (data && data.status === 1) {
   
      dispatch(updateValues({ ...formValues, ...formVal }));
      setLoading(false);
      setFormErrors("");
      setStudyFormErrors(false);
      window.allow_user_continue = true;
      navigate("/uploadpic");
    } else {
      setLoading(false);
      setFormErrors(data && data.message);
    }
  
  };
   const fetchStates = async () => {
     setStatesLoading(true);
     try {
       const { data, status } = await getStates(132);
       console.log("stateData",data)
       if (status === 200) {
         const location = data.data;
         const states = location.map((x) => {
           return { ...x, label: x.Name, value: x.Id };
         });
          setStates(states);
         if(formVal && formVal.school_state){
            const selectedState = states.find((val) => Number(val.value) === Number(formVal.school_state));
          setValue("school_state_abbr",selectedState?.label)
          setSelectedState(selectedState)
          fetchDistrict(selectedState)
         }
       }
     } finally {
       setStatesLoading(false);
     }
   };
      const fetchDistrict = async (val) => {
     setDistrictLoading(true);
     try {
       const { data, status } = await getDistrict(val.value);
       console.log("districtData",data)
       if (status === 200) {
         const location = data.data;
         const district = location.map((x) => {
           return { ...x, label: x.name, value: x.id };
         });
                setDistrict(district);

         if(formVal && formVal.school_district){
            const selectedDistrict = district?.find((val) => Number(val?.value) === Number(formVal?.school_district));
          setValue("school_district_abbr",selectedDistrict?.label)
          setSelectedDistrict(selectedDistrict)
          fetchSchools(val?.value,selectedDistrict?.value)
       }
      }
     } finally {
       setDistrictLoading(false);
     }
   };
 
  const multiDropdownChange = (name, val) => {
  //  console.log("valuesss", name, val);
    setValue(name, val.map((val) => val.value));
    setValue("elective_subjects", val.map((val) => val.value));    
    setValue("elective_subjects_abbr", val.map((val) => val.label));    
    clearErrors(name);
  switch (name) {
    case "form_6_subjects":
      setForm6SubjectsOption(val);
      break;
    case "elective_subjects_4_5":
      setElective_sub_45(val);
      break;
    case "elective_subjects_1_3":
      setElective_sub_13(val);
      break;
    default:
      break;
  }
  }

  const dropdownChange = (name, val) => {
    // console.log("valueEmpty",val.map((val) => val.value))
    console.log("valuesss",name,val)
    setValue(name, val.value);
    clearErrors(name);
    switch (name) {
      case "school_id":
        // setDisableStatus(false);
        setValue("school_name_abbr",val.label)
        const school_id = 'school_id';
        setSchoolName(val);
        dispatch(
          updateValues({
            ...formValues,
            ...formVal,
            [school_id]: val.value,
          })
        );
        break;
         case "school_state":
        setSelectedState(val);
        setSelectedDistrict(null);
        setValue("school_district", null);
        setValue("school_state_abbr",val.label)  
         setValue("school_id", null);
        setSchoolName(null);
        setSchoolListing([]);
        fetchDistrict(val);

        break;
         case "school_district":
        setSelectedDistrict(val);
        setValue("school_district_abbr",val.label)
        setValue("school_id", null);
        setSchoolName(null);
        fetchSchools(selectedState.value,val.value)
        break;
         case "form_6_subjects":
         setForm6SubjectsOption(val)
        break;
         case "elective_subjects_4_5":
          
         setElective_sub_45(val)
        break;
         case "elective_subjects_1_3":
         setElective_sub_13(val)
        break;
      case "spm_year":
        setValue("spm_year_abbr",val.label)
       setSPMYearValue(val)
        // setValue("curr_qualification_abbr", val.label);
        dispatch(
          updateValues({
            ...formValues,
            ...formVal,
            [name]: val.value,
          })
        );
      
        break;
      case "current_form":
        setValue("current_form_abbr",val.label)
        setValue("elective_subjects_4_5",[])
        setValue("elective_subjects_1_3",[])
        setValue("form_6_subjects",[])
        setValue("spm_year", null);
        setValue("stem_subject", null);
        setValue("stem_subject_abbr", "");
        setStemSubjectsValue();
       setCurrentFormValue(val)
       setForm6SubjectsOption();
       setElective_sub_13();
      //  setForm6Subjects([])
       setElective_sub_45()
       setSpmYearListing([])
       setSPMYearValue();
       setSpmYearDisabled(false);
      //  console.log("valvalue",val.value === 1)
       if (Number(val.value) === 6) {
    // Hide SPM year for Form 6
    setSpmYearDisabled(true);
    setSpmYearListingOverall([]);
    setValue("form_type", "Form 6 Subjects");
  } else {
        setSpmYearDisabled(false);
    const currentYear = new Date().getFullYear();
    let startYear;

    switch (Number(val.value)) {
      case 1:
        setValue("form_type", "Elective Subject(s) Form 1-3");
        startYear = currentYear + 4; // Form 1 → +4
        break;
      case 2:
        setValue("form_type", "Elective Subject(s) Form 1-3");
        startYear = currentYear + 3; // Form 2 → +3
        break;
      case 3:
        setValue("form_type", "Elective Subject(s) Form 1-3");
        startYear = currentYear + 2; // Form 3 → +2
        break;
      case 4:
        setValue("form_type", "Elective Subject(s) Form 4-5");
        startYear = currentYear + 1; // Form 4 → +1
        break;
      case 5:
          setValue("form_type", "Elective Subject(s) Form 4-5");
        startYear = currentYear; // Form 5 → current year
        break;
      default:
        startYear = currentYear;
    }
       const years = [];
    for (let year = startYear; year <= startYear + 39; year++) {
      years.push({ label: String(year), value: String(year) });
    }

    setSpmYearListingOverall(years);
  }
     
        break;
      case "stem_subject":
       setValue("stem_subject_abbr",val.label)
       setStemSubjectsValue(val)
        break;
      case "core_subjects":
        setValue("core_subjects_abbr",val.map((val) => val.label))
        setValue(name, val.map((item) => item.value));
        setCoreSubjectsValues(val)
        // setValue("curr_qualification_abbr", val.label);
        dispatch(
          updateValues({
            ...formValues,
            ...formVal,
            [name]: val.map((val) => val.value),
          })
        );
        break;
      case "elective_subjects":
       setElectiveSubjects(val)
       setValue(name, val.map((item) => item.value));
       setValue("elective_subjects_abbr",val.map((val) => val.label))
        // setValue("curr_qualification_abbr", val.label);
        dispatch(
          updateValues({
            ...formValues,
            ...formVal,
            [name]: val.map((val) => val.value),
          })
        );
        break;
   
      default:
    }
  };

  const onNavigate = (path) => {
    navigate(path);
  };

  const onSave = async () => {
      setLoading(true);
      const req = removeKeys({ ...formVal });
      const { data } = await onBoardFormSubmission({
        ...req,
        step: formValues.profile_picture ? 4 : 3,
        // step: 3
      });
      if (data && data.status === 1) {
  
        //---------
        if (formVal.insti_location_status === 0) {
          //study abroad
          if (formVal.insti_name) {
            formVal.insti_name = ''
            formVal.insti_name_abbr = formVal.university
          }
        } else if (formVal.insti_location_status === 1) {
          //study Locally
          if (formVal.university) {
            formVal.university = ""
          }
        }
  
  
        dispatch(updateValues({ ...formValues, ...formVal }));
        // dispatch(updateValues({ ...formVal, ...formValues }));
     
        //----------  
        navigate("/dashboard");
        setLoading(false);
        setFormErrors("");
      } else {
        setLoading(false);
        setFormErrors(data && data.message);
      }
  };







  const { t } = useTranslation();
    const stem_subjects_object = [
    {label: t("Yes"), value: "1"},
    {label: t("No"), value: "0"}
  ]
  const current_form_values= [  { label: t("Form") + ' 1', value: 1 },
  { label: t("Form") + ' 2', value: 2 },
  { label: t("Form") + ' 3', value: 3 },
  { label: t("Form") + ' 4', value: 4 },
  { label: t("Form") + ' 5', value: 5 },
  { label: t("Form") + ' 6', value: 6 },]
  const fetchSchools = async (stateID,districtID) => {
    setSchoolsLoading(true);
    try {
      const { data, status } = await getSchoolListingFilter(stateID,districtID);
      if (status === 200) {
          console.log("schoolListing",data)
        const schoolsList = data.data;
        const school_list = schoolsList.map((x) => {
          return { ...x, label: x.Name, value: x.Id };
        });

        setSchoolListing(school_list);

        if(formVal && formVal.school_id){
          console.log("schoolIds",formVal.school_id)
          const selectedSchool = school_list.find((val) =>  Number(val.value ) === Number(formVal.school_id) );
          setValue("school_name_abbr",selectedSchool?.label)
          setSchoolName(selectedSchool)
        }
      //   if (formVal.curr_study_year) {
      //     let selCurrstudyyear = Year_Of_Studies.filter(
      //       (x) => x.value == formVal.curr_study_year
      //     );
      //     if (selCurrstudyyear.length > 0) {
      //       selCurrstudyyear = selCurrstudyyear[0];
      //       setValue("curr_study_year", selCurrstudyyear.value);
      //     }
      //     setSchoolName(selCurrstudyyear);
      //   }
      }
    } finally {
      setSchoolsLoading(false);
    }
  };
  const fetchSchoolCourses = async () => {
    setCoursesLoading(true);
    try {
      const { data, status } = await getSchoolsCourses();
      if (status === 200) {
          console.log("schoolListing",data.data)

          let elective_subjects_1_3 = data.data.filter(course => course.course_type?.includes(1));
let elective_subjects_4_5 = data.data.filter(course => course.course_type?.includes(2));
let form_6_subjects = data.data.filter(course => course.course_type?.includes(3));

elective_subjects_1_3 = elective_subjects_1_3.map((x) => {
  return { ...x, label: x.course_name, value: x.id };
});
elective_subjects_4_5 = elective_subjects_4_5.map((x) => {
  return { ...x, label: x.course_name, value: x.id };
});
form_6_subjects = form_6_subjects.map((x) => {
  return { ...x, label: x.course_name, value: x.id };
});

console.log("formCurrentData",formVal.current_form,formVal.elective_subjects)
if(formVal && formVal.current_form >= 1 && formVal.current_form <= 3) {
    const selectedElective_sub_1_3 = elective_subjects_1_3.filter((val) => formVal.elective_subjects?.includes(val.value));
    setValue("elective_subjects_1_3_abbr",selectedElective_sub_1_3.map((val) => val.label))
    setElective_sub_13(selectedElective_sub_1_3)
    setValue("elective_subjects_1_3",selectedElective_sub_1_3.map((val) => val.value))
}
if(formVal && formVal.current_form >= 4 && formVal.current_form <= 5) {
    const selectedElective_sub_4_5 = elective_subjects_4_5.filter((val) => formVal.elective_subjects?.includes(val.value));
    setValue("elective_subjects_4_5_abbr",selectedElective_sub_4_5.map((val) => val.label))
    setElective_sub_45(selectedElective_sub_4_5)
    setValue("elective_subjects_4_5",selectedElective_sub_4_5.map((val) => val.value))
}
if(formVal && formVal.current_form === 6) {
    const selectedForm6Subjects = form_6_subjects.filter((val) => formVal.elective_subjects?.includes(val.value));
    setValue("form_6_subjects_abbr",selectedForm6Subjects.map((val) => val.label))
    setForm6SubjectsOption(selectedForm6Subjects)
    setValue("form_6_subjects",selectedForm6Subjects.map((val) => val.value))
}
console.log("elective_subjects_1_3",elective_subjects_1_3)
setElective_sub_1_3(elective_subjects_1_3)
setElective_sub_4_5(elective_subjects_4_5)
setForm6Subjects(form_6_subjects)

      }
    } finally {
      setCoursesLoading(false);
    }
  };


  useEffect(()=>{
    // console.log("formValuesData",formValues)
    fetchStates();
    // fetchSchools();
    fetchSchoolCourses();
  },[])

  
useEffect(()=>{
  console.log("formValcurrent_form",formVal)
      console.log("formValstate",formVal.school_state)

  if(formVal && formVal.stem_subject){
    setStemSubjectsValue(stem_subjects_object.find((val) => Number(val.value) === Number(formVal.stem_subject)))
  }
  if (formVal && formVal.current_form) {
    const currentFormData = secondaryFormValues.current_form_values.find(
      (val) => Number(val.value) === Number(formVal.current_form)
    );

    setValue("current_form_abbr", currentFormData?.label);
    setCurrentFormValue(currentFormData);

    // Handle SPM Year logic similar to onChange
    if (Number(currentFormData?.value) === 6) {
      // Hide SPM year for Form 6
      setSpmYearDisabled(true);
      setSpmYearListingOverall([]);
    } else {
      setSpmYearDisabled(false);

      const currentYear = new Date().getFullYear();
      let startYear;

      switch (Number(currentFormData?.value)) {
        case 1:
          startYear = currentYear + 4;
          break;
        case 2:
          startYear = currentYear + 3;
          break;
        case 3:
          startYear = currentYear + 2;
          break;
        case 4:
          startYear = currentYear + 1;
          break;
        case 5:
          startYear = currentYear;
          break;
        default:
          startYear = currentYear;
      }

      // Build year list
      const years = [];
      for (let year = startYear; year <= startYear + 39; year++) {
        years.push({ label: String(year), value: String(year) });
      }

      setSpmYearListingOverall(years);

      // Restore selected SPM year if available
      const spmYear = years.find(
        (val) => Number(val.value) === Number(formVal.spm_year)
      );
      setValue("spm_year_abbr", spmYear?.label);
      setSPMYearValue(spmYear);
    }
  }
},[])
  
  return (
    <UserCreationLayout sidebarImg={internshipImg}>
      <IntroSection
        name={t(secondaryStudentContent.title)}
        description={t(secondaryStudentContent.description)}
      />
      <PaginationDivider step={2} />
      <FormWrapper>
        {/* scholarship fields starts */}
        
        <Row>
          <Col>
            <FormGroup>
              <LabelText>{t(secondaryStudentContent.state) + "*"}</LabelText>
              <Controller
                name="school_state"
                control={control}
                render={({ field }) => (
                  <Dropdown
                    search={true}
                    // options={selectState && selectState.curr_country}
                    options={states}
                    placeholder= {t("Select State")}
                    change={(val) => dropdownChange("school_state", val)}
                    //val={formVal.state}
                    val={selectedState?.value}
                    label={selectedState?.label}
                    load={statesLoading}
                    //disable={formVal.curr_qualification ? false : true}
                    // onFocus={() => {getOptions('SL')}}
                    {...field}
                    refCallback={field?.ref}
                    ref={null}
                  />
                )}
              />
              {errors.school_state && (
                <ErrorField err={t(errors.school_state.message)} />
              )}
            </FormGroup>
          </Col>
        </Row>
                <Row>
          <Col>
            <FormGroup>
              <LabelText>{t(secondaryStudentContent.district) + "*"}</LabelText>
              <Controller
                name="school_district"
                control={control}
                render={({ field }) => (
                  <Dropdown
                    search={true}
                    // options={selectState && selectState.curr_country}
                    options={district}
                    placeholder= {t("Select District")}
                    change={(val) => dropdownChange("school_district", val)}
                    //val={formVal.state}
                    val={selectedDistrict?.value}
                    label={selectedDistrict?.label}
                    load={districtLoading}
                    //disable={formVal.curr_qualification ? false : true}
                    // onFocus={() => {getOptions('SL')}}
                    {...field}
                    refCallback={field?.ref}
                    ref={null}
                  />
                )}
              />
              {errors.school_district && (
                <ErrorField err={t(errors.school_district.message)} />
              )}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <LabelText>{t(secondaryStudentContent.school_name) + "*"}</LabelText>
              <Controller
                name="school_id"
                control={control}
                render={({ field }) => (
                  <Dropdown
                    search={true}
                    // options={selectState && selectState.curr_country}
                    options={schoolListing}
                    placeholder= {t("Select the School Name")}
                    change={(val) => dropdownChange("school_id", val)}
                    //val={formVal.state}
                    val={schoolName?.value}
                    label={schoolName?.label}
                    load={schoolsLoading}
                    //disable={formVal.curr_qualification ? false : true}
                    // onFocus={() => {getOptions('SL')}}
                    {...field}
                    refCallback={field?.ref}
                    ref={null}
                  />
                )}
              />
              {errors.school_id && (
                <ErrorField err={t(errors.school_id.message)} />
              )}
            </FormGroup>
          </Col>
        </Row>

        <Row>
              <Col>
                <FormGroup>
                  <LabelText>{t(secondaryStudentContent.current_form)+ "*"}</LabelText>
                  <Controller
                    name="current_form"
                    control={control}
                    render={({ field }) => (
                      <Dropdown
                        search={true}
                        options={current_form_values}
                        placeholder={t("Select the Current Form")}
                        //val={formVal.insti_name}
                        val={currentFromValue?.value}
                        label={t(currentFromValue?.label)}
                        change={(val) => dropdownChange("current_form", val)}
                        {...field}
                        refCallback={field?.ref}
                        ref={null}
                      />
                    )}
                  />
                  {errors.current_form && (
                    <ErrorField err={t(errors.current_form.message)} />
                  )}
                </FormGroup>
              </Col>
            </Row>
         { currentFromValue?.value !== 6 &&  <Row>
              <Col>
                <FormGroup>
                  <LabelText>{t(secondaryStudentContent.spm_year) + "*"}</LabelText>
                  <Controller
                    name="spm_year"
                    control={control}
                    render={({ field }) => (
                      <Dropdown
                        search={true}
                        options={ spmYearListingOverall}
                        placeholder={t("Select the SPM Year")}
                        //val={formVal.insti_name}
                        disable={spmYearDisabled}
                        val={spmYearValue?.value}
                        label={spmYearValue?.label}
                        change={(val) => dropdownChange("spm_year", val)}
                        {...field}
                        refCallback={field?.ref}
                        ref={null}
                      />
                    )}
                  />
                  {errors.spm_year && (
                    <ErrorField err={t(errors.spm_year.message)} />
                  )}
                </FormGroup>
              </Col>
            </Row>}

            {
               currentFromValue?.value >= 1 && currentFromValue?.value <= 3 && <Row>
              <Col>
                <FormGroup>
                  <LabelText>{t(secondaryStudentContent.elective_subjects_1_3) + "*"}</LabelText>
                  <Controller
                    name="elective_subjects_1_3"
                    control={control}
                    render={({ field }) => (
                      <MultiSelector
                        search={true}
                        isMulti
                        options={elective_sub_1_3}
                        placeholder={t("Select the Elective Subjects")}
                        //val={formVal.insti_name}
                        val={elective_sub_13}
                        // label={electiveSubjectsValues?.label}
                        load={coursesLoading}
                        change={(val) => multiDropdownChange("elective_subjects_1_3", val)}
                        {...field}
                        refCallback={field?.ref}
                        ref={null}
                      />
                    )}
                  />
                  {errors.elective_subjects_1_3 && (
                    <ErrorField err={t(errors.elective_subjects_1_3.message)} />
                  )}
                </FormGroup>
              </Col>
            </Row> }
              {currentFromValue?.value >= 4 && currentFromValue?.value <= 5 && <Row>
              <Col>
                <FormGroup>
                  <LabelText>{t(secondaryStudentContent.stem_subjects)+ "*"}</LabelText>
                  <Controller
                    name="stem_subject"
                    control={control}
                    render={({ field }) => (
                      <Dropdown
                        search={true}
                        
                        options={stem_subjects_object}
                        placeholder={t("Select")}
                        //val={formVal.insti_name}
                        val={stemSubjectsValue?.value}
                        label={t(stemSubjectsValue?.label)}
                        change={(val) => dropdownChange("stem_subject", val)}
                        {...field}
                        refCallback={field?.ref}
                        ref={null}
                      />
                    )}
                  />
                  {errors.stem_subject && (
                    <ErrorField err={t(errors.stem_subject.message)} />
                  )}
                </FormGroup>
              </Col>
            </Row>}
    {currentFromValue?.value >= 4 && currentFromValue?.value <= 5 &&
                <Row>
              <Col>
                <FormGroup>
                  <LabelText>{t(secondaryStudentContent.elective_subjects_4_5) + "*"}</LabelText>
                  <Controller
                    name="elective_subjects_4_5"
                    control={control}
                    render={({ field }) => (
                      <MultiSelector
                        search={true}
                        isMulti
                        options={elective_sub_4_5}
                        placeholder={t("Select the Elective Subjects")}
                        //val={formVal.insti_name}
                        val={elective_sub_45}
                        // label={electiveSubjectsValues?.label}
                        load={coursesLoading}
                        change={(val) => multiDropdownChange("elective_subjects_4_5", val)}
                        {...field}
                        refCallback={field?.ref}
                        ref={null}
                      />
                    )}
                  />
                  {errors.elective_subjects_4_5 && (
                    <ErrorField err={t(errors.elective_subjects_4_5.message)} />
                  )}
                </FormGroup>
              </Col>
            </Row> }

                { currentFromValue?.value == 6 &&
                <Row>
              <Col>
                <FormGroup>
                  <LabelText>{t(secondaryStudentContent.form_6_subjects) + "*"}</LabelText>
                  <Controller
                    name="form_6_subjects"
                    control={control}
                    render={({ field }) => (
                      <MultiSelector
                        search={true}
                        isMulti
                        options={form_6_subject}
                        placeholder={t("Select Form 6 Subjects")}
                        //val={formVal.insti_name}
                        val={form6SubjectsOption}
                        // label={electiveSubjectsValues?.label}
                        load={coursesLoading}
                        change={(val) => multiDropdownChange("form_6_subjects", val)}
                        {...field}
                        refCallback={field?.ref}
                        ref={null}
                      />
                    )}
                  />
                  {errors.form_6_subjects && (
                    <ErrorField err={t(errors.form_6_subjects.message)} />
                  )}
                </FormGroup>
              </Col>
            </Row> }
      

       
       
        {formErrors && <ErrorField err={t(formErrors)} />}
        {
        loading ? (
          <Loader />
        ) : 
        (
          <>
            <ButtonWrapper>
              <Button
                width="198px"
                onClick={handleSubmit(onSubmit, onErrorSubmit)}
                name={t("Continue")}
              />
              <Button
                width="198px"
                onClick={() => onNavigate("/aboutme")}
                secondary={true}
                name={t("Back")}
              />
            </ButtonWrapper>
            {formValues.profile_picture === "" ? (
              ""
            ) : (
              <SaveButton onClick={handleSubmit(onSave)}>
                {t("Save and Exit")}
              </SaveButton>
            )}
          </>
        )}
        {studyFormErrors && (
          <ErrorField
            err={t("Please make sure all the mandatory fields have been inserted")}
          />
        )}
      </FormWrapper>
    </UserCreationLayout>
  );
}
